module.exports = __webpack_public_path__ + "static/img/14.a997e0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/14.png
// module id = Gv5H
// module chunks = 0